// Single source of truth for the BiteGoFood launch commercial creative package.
const IMG = "https://static.prod-images.emergentagent.com/jobs/9a77ee41-128e-41e3-beb2-5955a16f7b7a/images";

export const IMAGES = {
  ownerChallenge: `${IMG}/53efc6bd7e60c4f835ed54c2e0f6a45596718054315c17f57176f8d314164eaa.jpeg`,
  kitchenPass: `${IMG}/8a9641a5e735de2b27db7a482f43aeee80588a4e2b50a19f52a937b560d4354d.jpeg`,
  customerPhone: `${IMG}/e965cdaf993f68dd69a51078f32d820f44562cf24a2a9044b79121491573bcfa.jpeg`,
  ownerConfident: `${IMG}/821f4ab8990f0504371d769e9ebf45a0fdcf8cda68dba419a5c8a2b837c11768.jpeg`,
  orderingHands: `${IMG}/79d0d91471e982c046f4abf68f06afe99d30bae919dfd91764032e2a82fb9915.jpeg`,
  growthStaff: `${IMG}/45cce2290731dd32b6e7f0871a99d60692d7e6933497a107f978126fa4c43862.jpeg`,
  foodFlatlay: `${IMG}/a33721e34f1bd4d6c46214541f85b8951cbe07fc38474ac45d6bc63447480a44.jpeg`,
  deliveryRider: `${IMG}/5e56aafdd2d3297d913b2c25f78b05d4b2215561c7391c9de8e8efc825222d36.jpeg`,
  restaurantExterior: `${IMG}/688da0246cd9646762d48a1e4ba8999ab6263a63651d2417fdc17c3ff5814fd1.jpeg`,
  ctaGradient: `${IMG}/9a37370d43718635e771189082b4459456ac1b79bffea2a53928dd7b59add92f.jpeg`,
};

export const BRAND = {
  name: "BiteGoFood",
  tagline: "Food Near You, Faster Than Ever.",
  website: "bitego.org",
  websiteUrl: "https://bitego.org",
  poweredBy: "A Product by Vijay Software Solutions Pvt Ltd",
  partnerEmail: "info@vs-solutions.org",
  logo: "/bitegofood-logo.png",
  orange: "#F97316",
  red: "#E11D48",
};

// Telugu voice-over subtitles (matching the Telugu VO) + short no-VO captions.
// On-screen graphics stay in English per brief.
export const TE = {
  s1: {
    vo: "రెస్టారెంట్ నడపడం అంత తేలిక కాదు. ఎక్కువ కమిషన్లు, సంక్లిష్టమైన నిర్వహణ, పరిమిత ఆన్‌లైన్ రీచ్ — ఇవి మీ కష్టాన్ని మరింత పెంచకూడదు.",
    caption: "రెస్టారెంట్ నడపడం తేలిక కాదు.",
  },
  s2: {
    vo: "పరిచయం చేస్తున్నాం, BiteGoFood. మీ రెస్టారెంట్‌ను మరింత మంది కస్టమర్లతో కలిపే ఆధునిక ఫుడ్ డెలివరీ ప్లాట్‌ఫారమ్.",
    caption: "పరిచయం — BiteGoFood.",
  },
  s3: {
    vo: "BiteGoFood తో, రెస్టారెంట్లు కేవలం పద్దెనిమిది శాతం కమిషన్ మాత్రమే చెల్లిస్తారు. కస్టమర్లకు స్పష్టమైన ధరలు — ఫుడ్ ఖర్చు, దానికి వర్తించే డెలివరీ ఫీజు.",
    caption: "కేవలం 18% కమిషన్. స్పష్టమైన ధరలు.",
  },
  s4: {
    vo: "మీ మెనూ మేనేజ్ చేయండి, లైవ్ ఆర్డర్లు అందుకోండి, డెలివరీలను ట్రాక్ చేయండి, సేల్స్ చూసుకోండి, ఆఫర్లను ప్రమోట్ చేయండి, కొత్త కస్టమర్లను చేరుకోండి — అన్నీ ఒకే ప్లాట్‌ఫారమ్‌లో.",
    caption: "అన్నీ ఒకే ప్లాట్‌ఫారమ్‌లో.",
  },
  s5: {
    vo: "కస్టమర్ల కోసం — రెస్టారెంట్లను కనుగొనడం, ఫుడ్ ఆర్డర్ చేయడం, డెలివరీని ట్రాక్ చేయడం BiteGoFood తో చాలా సులభం.",
    caption: "కనుగొనండి. ఆర్డర్ చేయండి. ట్రాక్ చేయండి.",
  },
  s6: {
    vo: "మీ వంటకాలకు మరింత పెద్ద ప్రేక్షకులు అర్హులు. స్థానిక రెస్టారెంట్లు డిజిటల్‌గా ఎదగడానికి, మరింత మంది కస్టమర్లను చేరుకోవడానికి BiteGoFood సహాయపడుతుంది.",
    caption: "మరింత మంది కస్టమర్లను చేరుకోండి.",
  },
  s7: {
    vo: "మీ రెస్టారెంట్‌ను వృద్ధి చేసుకోవడానికి సిద్ధంగా ఉన్నారా? bitego.org సందర్శించండి, ఈరోజే BiteGoFood ని కనుగొనండి.",
    caption: "bitego.org సందర్శించండి.",
  },
};

// Restaurant-facing feature set — shown, never exaggerated.
export const FEATURES = [
  { label: "Restaurant Dashboard", icon: "LayoutDashboard" },
  { label: "Live Order Management", icon: "BellRing" },
  { label: "Digital Menu", icon: "BookOpen" },
  { label: "Online Payments", icon: "CreditCard" },
  { label: "Order Tracking", icon: "Navigation" },
  { label: "Sales & Order Analytics", icon: "BarChart3" },
  { label: "Promotions & Offers", icon: "Tag" },
  { label: "Customer Reach", icon: "Users" },
  { label: "Easy Restaurant Registration", icon: "Store" },
  { label: "Dedicated Support", icon: "Headphones" },
];

// Ordered scene list. `dur` in seconds; total = 60s.
export const SCENES = [
  {
    id: "s1",
    index: 1,
    dur: 8,
    chapter: "The Challenge",
    variant: "headline",
    image: IMAGES.ownerChallenge,
    vo: "Running a restaurant is hard enough. High commissions, complicated operations, and limited online reach shouldn't make it harder.",
    caption: "Running a restaurant is hard enough.",
    shot: "Premium Indian restaurant — owner checks his phone at the busy kitchen pass while chefs plate food. Subtle sense of expense pressure, fragmented operations and limited reach. No competitor names, no fake dashboards.",
    overlay: {
      eyebrow: "The Challenge",
      big: "Your Food. Your Restaurant. Your Growth.",
      sub: "High commissions and limited reach shouldn't hold you back.",
    },
  },
  {
    id: "s2",
    index: 2,
    dur: 8,
    chapter: "Meet BiteGoFood",
    variant: "brand",
    image: IMAGES.customerPhone,
    vo: "Introducing BiteGoFood — a modern food delivery platform, built to connect restaurants with more customers.",
    caption: "Meet BiteGoFood.",
    shot: "Logo reveal using the real BiteGoFood icon. Customer browsing restaurants and menus on a phone. Website integrated cleanly. Conceptual UI stays generic and branded.",
    overlay: {
      eyebrow: "Introducing",
      big: "Meet BiteGoFood",
      sub: "Food Near You, Faster Than Ever",
      pill: "bitego.org",
    },
  },
  {
    id: "s3",
    index: 3,
    dur: 10,
    chapter: "Only 18% Commission",
    variant: "commission",
    image: IMAGES.ownerConfident,
    vo: "With BiteGoFood, restaurants pay only an 18 percent commission. And customers see transparent pricing: food cost, plus the applicable delivery fee.",
    caption: "Only 18% commission. Transparent pricing.",
    shot: "Bold typographic hero moment. Owner receives orders with calm operational control. Clean control cues — no fake earnings graphs. Strongest numeric claim of the film.",
    overlay: {
      eyebrow: "The Core Advantage",
      big: "ONLY 18% COMMISSION",
      sub: "Simple. Clear. Transparent.",
      pricingTitle: "Transparent customer pricing",
      pricingLine: "Food Cost + applicable Delivery Fee",
    },
  },
  {
    id: "s4",
    index: 4,
    dur: 12,
    chapter: "Restaurant Benefits",
    variant: "features",
    image: IMAGES.kitchenPass,
    vo: "Manage your menu, receive live orders, track deliveries, monitor sales, promote your offers, and reach new customers — all from one platform.",
    caption: "Everything you need — in one platform.",
    shot: "Fast feature montage: dashboard-style UI, phones, order cards, analytics cards, offer banners alongside real Indian restaurant operations. Only listed features shown.",
    overlay: {
      eyebrow: "For Restaurants",
      big: "One platform. Everything you need.",
    },
  },
  {
    id: "s5",
    index: 5,
    dur: 8,
    chapter: "Customer Experience",
    variant: "flow",
    image: IMAGES.orderingHands,
    vo: "For customers, BiteGoFood makes discovering restaurants, ordering food, and tracking deliveries simple.",
    caption: "Discover. Order. Track. Enjoy.",
    shot: "Search → Restaurant → Menu → Add to Cart → Checkout → Order Tracking. Attractive Indian dishes, modern phone interactions, delivery progress. Clear even on mute.",
    overlay: {
      eyebrow: "For Customers",
      big: "Discover. Order. Track. Enjoy.",
      steps: ["Discover", "Order", "Track", "Enjoy"],
    },
  },
  {
    id: "s6",
    index: 6,
    dur: 7,
    chapter: "Restaurant Growth",
    variant: "growth",
    image: IMAGES.growthStaff,
    vo: "Your food deserves a bigger audience. BiteGoFood helps local restaurants grow digitally and reach more customers.",
    caption: "Reach more customers. Grow digitally.",
    shot: "Owner smiling, steady order flow, staff working efficiently. Motion callouts around visibility and control. No guaranteed-orders implication.",
    overlay: {
      eyebrow: "The Opportunity",
      lines: ["MORE CUSTOMERS", "MORE VISIBILITY", "BETTER CONTROL"],
    },
  },
  {
    id: "s7",
    index: 7,
    dur: 7,
    chapter: "Final CTA",
    variant: "cta",
    image: IMAGES.ctaGradient,
    vo: "Ready to grow your restaurant? Visit bitego.org, and discover BiteGoFood today.",
    caption: "Visit bitego.org",
    shot: "Premium BiteGoFood logo animation, product montage softly looping behind CTA. Website and powered-by lockup. Final frame holds long enough to read on mobile.",
    overlay: {
      big: "Grow Your Restaurant.",
      big2: "Reach More Customers.",
      commission: "ONLY 18% COMMISSION",
      cta: "Visit bitego.org",
    },
  },
];

export const TOTAL_DURATION = SCENES.reduce((a, s) => a + s.dur, 0);

// Cumulative start offset (seconds) for each scene, plus total.
export const OFFSETS = (() => {
  let acc = 0;
  const map = {};
  SCENES.forEach((s) => {
    map[s.id] = acc;
    acc += s.dur;
  });
  return { map, total: acc };
})();

export const LEGAL_NOTES = [
  "18% commission is the single strongest numeric claim — validate it against actual commercial terms for every audience before publishing.",
  "Customer pricing is shown only as “Food Cost + applicable Delivery Fee”. No GST / tax / “no-tax” wording is used.",
  "No guaranteed growth, orders, savings or revenue is claimed. Growth language stays as “reach more customers” and “more visibility”.",
  "No fake reviews, fake metrics, fake partners or invented product capabilities appear anywhere.",
  "Only the listed real features are shown. Keep “Dedicated Support”, “Online Payments” and “Order Tracking” only while they remain operationally true.",
  "No competitor names, UI mimicry or competitor colour systems are used. Palette is derived from the BiteGoFood logo.",
];
